import { createContext, PropsWithChildren, useContext } from 'react';

interface TinyMCEContextProps {
  apiKey: string;
}

const TinyMCEContext = createContext<TinyMCEContextProps | undefined>(
  undefined
);

const TinyMCEProvider: React.FC<PropsWithChildren<{ apiKey: string }>> = ({
  children,
  apiKey,
}) => (
  <TinyMCEContext.Provider value={{ apiKey }}>
    {children}
  </TinyMCEContext.Provider>
);

const useTinyMCEContext = (): TinyMCEContextProps => {
  const context = useContext(TinyMCEContext);
  if (!context) {
    throw new Error('useTinyMCEContext must be used within an TinyMCEProvider');
  }
  return context;
};

export { TinyMCEProvider, useTinyMCEContext };
